import { useScheduleStore } from "@/Modules/Schedule/Store";
import useAppStore from "@/Modules/App/Store";

import { deleteAppointment } from "@/Services/TherapyApi/Schedule";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { danger } from "@/Utils/Debug";

const DeleteAppointmentActionHandler = async (appointmentUuid: string) => {
  const scheduleStore = useScheduleStore();
  const appStore = useAppStore();

  scheduleStore.isLoading = true;

  try {
    await deleteAppointment(appointmentUuid);

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "patient.chat.schedule.appointment.button.delete.confirm",
    });
  } catch (err) {
    danger(err);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "patient.chat.schedule.appointment.button.delete.error",
    });
  } finally {
    scheduleStore.isLoading = false;
  }
};

export default DeleteAppointmentActionHandler;
